import invitation_border1 from "../images/engagement/engagement_invitation_border1.png";
import invitation_border2 from "../images/engagement/engagement_invitation_border2.png";
import venkateswara_swami from "../images/engagement/engagement_logo.png";
import '../invitations/Invitation.css'

const engagementInvitationElements = [
{
id:1,
type:"image",
src:invitation_border1,
x:0,
y:20,
width:300,
height:30
},
{
id:2,
type:"image",
src:invitation_border1,
x:300,
y:20,
width:300,
height:30
},
{
id:17,
type:"image",
src:invitation_border1,
x:0,
y:800,
width:300,
height:30
},
{
id:18,
type:"image",
src:invitation_border1,
x:300,
y:800,
width:300,
height:30
},
{
id:19,
type:"image",
src:invitation_border2,
x:10,
y:20,
width:20,
height:300
},
{
id:20,
type:"image",
src:invitation_border2,
x:10,
y:310,
width:20,
height:300
},
{
id:21,
type:"image",
src:invitation_border2,
x:10,
y:500,
width:20,
height:300
},
{
id:22,
type:"image",
src:invitation_border2,
x:570,
y:20,
width:20,
height:300
},
{
id:23,
type:"image",
src:invitation_border2,
x:570,
y:310,
width:20,
height:300
},
{
id:24,
type:"image",
src:invitation_border2,
x:570,
y:500,
width:20,
height:300
},
{
id:3,
type:"text",
text:"💍 Engagement Invitation 💫",
x:30,
y:70,
fontSize:35,
fontFamily:"Cinzel",
fill:"#cf0b0b"
},
{
id:4,
type:"text",
text:"Together with their families,",
x:150,
y:150,
fontSize:30,
fontFamily:"Dancing Script",
fill:"#cf0b0b"
},
{
id:5,
type:"text",
text:"Rahul ❤️ Priya",
x:200,
y:200,
fontSize:30,
fontFamily:"Raleway",
fill:"#cf0b0b"
},
{
id:6,
type:"text",
text:"joyfully invite you to celebrate their engagement.",
x:50,
y:530,
fontSize:30,
fontFamily:"Dancing Script",
fill:"#cf0b0b"
},
{
id:7,
type:"text",
text:"💍 Engagement Ceremony 📅 Sunday, 15/03/2026 ⏰ 06:00 pm",
x:20,
y:560,
fontSize:20,
fontFamily:"Cardo",
fill:"#cf0b0b"
},
{
id:8,
type:"text",
text:"📍 Venue:",
x:90,
y:600,
fontSize:22,
fontFamily:"Josefin Sans",
fill:"#cf0b0b"
},
{
id:9,
type:"text",
text:"ABC FUNCTION HALL",
x:200,
y:620,
fontSize:20,
fontFamily:"Josefin Sans",
fill:"#cf0b0b"
},
{
id:10,
type:"text",
text:"City / Address",
x:200,
y:640,
fontSize:20,
fontFamily:"Josefin Sans",
fill:"#cf0b0b"
},
{
id:11,
type:"text",
text:"Your presence and blessings",
x:120,
y:670,
fontSize:28,
fontFamily:"Dancing Script",
fill:"#cf0b0b"
},
{
id:12,
type:"text",
text:"will make this moment even more special.",
x:100,
y:700,
fontSize:28,
fontFamily:"Dancing Script",
fill:"#cf0b0b"
},
{
id:13,
type:"text",
text:"With love,",
x:150,
y:740,
fontSize:22,
fontFamily:"Great Vibes",
fill:"#cf0b0b"
},
{
id:14,
type:"text",
text:"Rahul & Priya",
x:150,
y:770,
fontSize:22,
fontFamily:"Great Vibes",
fill:"#cf0b0b"
},
{
id:15,
type:"text",
text:"📞 648200xxxx",
x:290,
y:770,
fontSize:22,
fontFamily:"Great Vibes",
fill:"#cf0b0b"
},
{
id:16,
type:"image",
src:venkateswara_swami,
x:150,
y:250,
width:290,
height:270
}
];

export default engagementInvitationElements;